import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import StyledShoppingCartModal from "./addToBagStyles";
import { SHOPPING_CART_MODAL } from "../../../constants/lang";
import { useShoppingCart } from "../../../context/ShoppingCartContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getFormattedDate } from "../../../utils/commonFuntions";

const ReplaceTrip = ({ tripDetails, onToggle }) => {
  const getText = () => {
    if (tripDetails?.hotel_name?.lenngth || tripDetails?.city_name?.length || tripDetails?.arrival_date?.length) {
      return "from ";
    }
  }
  const { bagItems } = useShoppingCart();
  return (
    <StyledShoppingCartModal>
      <Box className="replace-trip-container">
        <Box marginBottom="30px" display={"flex"} alignItems={"center"} gap={1.5}>
          <IconButton onClick={() => onToggle()}>
            <ArrowBackIcon />
          </IconButton>
          <Typography className="replace-title">
            {SHOPPING_CART_MODAL.headings.replacetitle}
          </Typography>
        </Box>
        <Typography className="replace-description">
          {SHOPPING_CART_MODAL.messages.replacedescription1}
          {getText()}
          <span className="text-bold">
            {tripDetails?.hotel_name ? `${tripDetails?.hotel_name}, ` : ""}
            {tripDetails?.city_name ? `${tripDetails?.city_name}, ` : ""}
            {getFormattedDate(tripDetails?.arrival_date) || ""}
          </span>
          {!!bagItems?.length && <>
            {SHOPPING_CART_MODAL.messages.replacedescription2}
            <span className="text-bold">
              {bagItems?.length}
              {bagItems?.length && SHOPPING_CART_MODAL.messages.replacedescription4}
            </span>
          </>}
          {SHOPPING_CART_MODAL.messages.replacedescription3}
        </Typography>
      </Box>
    </StyledShoppingCartModal>

  );
};

export default ReplaceTrip;
